import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import {
  GetLineVisitDetailDocument,
  GetLineVisitDetailQuery,
  LineVisitorAppointmentDetailFragment,
  LineVisitorDetailFragment,
} from '~/graphql/generated/graphql';

const getPatientName = (data?: GetLineVisitDetailQuery) => {
  if (!data?.node) return '';
  const appointment = data.node as LineVisitorAppointmentDetailFragment;

  const { familyName, givenName } = appointment.lineVisitor as LineVisitorDetailFragment;

  return `${familyName}${givenName}`;
};

const getOrganizationName = (data?: GetLineVisitDetailQuery) => {
  if (!data?.node) return '';
  const appointment = data.node as LineVisitorAppointmentDetailFragment;
  const organization = appointment.organization;
  return organization.name;
};

type Props = {
  appointmentId?: string | null;
};

export const useFetchLineVisitorAndOrganizationName = ({ appointmentId }: Props) => {
  const [getLineVisitorProfile, { data: lineVisitorData }] = useLazyQuery(
    GetLineVisitDetailDocument,
  );
  const patientName = getPatientName(lineVisitorData);
  const organizationName = getOrganizationName(lineVisitorData);

  useEffect(() => {
    (async () => {
      if (appointmentId) {
        await getLineVisitorProfile({ variables: { id: appointmentId } });
      }
    })();
  }, [getLineVisitorProfile, appointmentId]);

  return { patientName, organizationName };
};
